import React from "react";
import ReactDOM from "react-dom/client";
import "@/sentry";  // must load before App so errors are captured from the first render
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
